import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-right"
}
const _hoisted_2 = ["onClick"]

import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store";
import { useRoute } from "vue-router";
import AccountService from "../../accounts/services/AccountService";
import { Actions } from "@/store/enums/StoreEnums";
import { AccountRoleTypes } from "@/core/types/AccountInfos";


export default /*#__PURE__*/_defineComponent({
  __name: 'RepSelector',
  setup(__props) {

const store = useStore();
const route = useRoute();

const repAccount = ref(store.state.RepModule.repAccount);
const repAccounts = ref([]);
onMounted(async () => {
  // console.log("mounted");
  const res = await AccountService.queryAccounts({
    role: AccountRoleTypes.Rep,
  });
  if (res.data.length === 0) return;
  repAccounts.value = res.data;

  if (repAccounts.value.length > 0) {
    await store.dispatch(Actions.PUT_REP_ACCOUNT, {
      uid: res.data[0].uid,
    });
  }
  repAccount.value = {
    uid: res.data[0].uid,
  };
});

const showRepSelector = computed(() => /^\/rep/.test(route.path));

const changeRepAccount = (uid: number) => {
  if (uid === repAccount.value.uid) return;
  store.dispatch(Actions.PUT_REP_ACCOUNT, {
    uid,
  });
  repAccount.value = { uid };
};

return (_ctx: any,_cache: any) => {
  return (showRepSelector.value && repAccounts.value.length >= 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repAccounts.value, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(["btn btn-small me-2 cursor-pointer", {
        'btn-light': repAccount.value.uid === item.uid,
        'btn-primary': repAccount.value.uid !== item.uid,
      }]),
            key: item.uid,
            onClick: ($event: any) => (changeRepAccount(item.uid))
          }, _toDisplayString(item.uid), 11, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})